import { createSelector } from '@ngrx/store';
import * as fromPaymentsReducer from '../reducers';
import * as fromPaymentRunSUmmaryReducer from '../reducers/payment-run-summary.reducer';

export const selectPaymentRunSummary = createSelector(
    fromPaymentsReducer.selectPaymentRunSummaryState,
    fromPaymentRunSUmmaryReducer.loadPaymentRunSummaryResponse
  );